import { ExportDataIcon } from "../images";
import { toast } from "react-toastify";
import { CustomToast } from "../ui/CustomToast";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { useEffect } from "react";
import { useExportUserDataMutation } from "../../api";
import { MenuNavButton } from "../ui/buttons";

type Props = {
  onSuccess?: () => void;
};

export const ExportEmailsButton = ({ onSuccess }: Props) => {
  const [exportUserData, { isLoading, isSuccess, isError, error, data }] =
    useExportUserDataMutation();

  const downloadCSV = (csvString: string, filename = "users_data.csv") => {
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    link.click();
  };

  useEffect(() => {
    if (isError && error) {
      toast.error(
        <CustomToast
          type={"error"}
          text={
            getErrorMessage(error).globalError ||
            "Something went wrong. Please try again"
          }
          title={"Export Data Failed"}
        />,
      );
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess && data) {
      onSuccess && onSuccess();
      downloadCSV(data);
    }
  }, [isSuccess]);

  return (
    <MenuNavButton
      isLoading={isLoading}
      isDisabled={isLoading}
      handler={() => exportUserData()}
      text="Export Hashed Emails"
      icon={<ExportDataIcon color="#4C545B" />}
    />
  );
};
